let stringToNumber = (val) => {
    return parseInt(val);
}

let stringToBoolean = (val) => {
    return val === 'true'
}

export default {
    stringToNumber: stringToNumber,
    stringToBoolean: stringToBoolean
}